import { Grid } from '@mui/material';
import { Submotive1DataProps } from './props';
import { useSubmotive1Data } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const Submotive1Data = (props: Submotive1DataProps) => {
    const { formik, types, motives } = useSubmotive1Data(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <AutocompleteField
                    data={formatParams(types)}
                    label="Tipo PQR"
                    name="nestedParent"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.nestedParent}
                    errors={formik.errors.nestedParent}
                    value={formik.values.nestedParent}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('nestedParent', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <AutocompleteField
                    data={formatParams(motives)}
                    label="Motivo"
                    name="parent"
                    size="small"
                    required
                    disabled={motives.length === 0}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.parent}
                    errors={formik.errors.parent}
                    value={formik.values.parent}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('parent', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra2"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.extra2}
                    errors={formik.errors.extra2}
                    value={formik.values.extra2}
                    onChange={formik.handleChange}
                    required={!!props?.data?.id}
                />
            </Grid>
        </Grid>
    );
};
